<mat-form-field [ngClass]="classes" class="select-search-api override-hide-placeholder">
  @if (label && !(classes && classes.includes('inline'))) {
    <mat-label>{{label}}@if (required) {
      <span class="label-required"></span>
    }</mat-label>
  }
  @if (label && (classes && classes.includes('inline'))) {
    <label>{{label}}@if (required) {
      <span class="label-required"></span>
    }</label>
  }
  @if (!label) {
    <mat-label></mat-label>
  }
  <mat-select #matSelect (openedChange)="openedChange($event)"
              (selectionChange)="emitSelect($event)"
              [(ngModel)]="value"
              [compareWith]="compareWith"
              [disabled]="disabled"
              [placeholder]="getPlaceholder()"
              (infiniteScroll)="getNextBatch()"
              [complete]="!sapi.loadNext" msInfiniteScroll
              [panelClass]="panelClasses" [ngClass]="{'placeholder-text': selectedTriggerText===placeholderText}"
              panelClass="select-search-dropdown-panel"
  >
    <mat-select-trigger [dblClickCopy]="value?.attributes?.name" [appProcessMenu]="value">
      {{getPlaceholder()}}
    </mat-select-trigger>

    <div class="select-container">
      <option-list-search (keydown.space)="$event.stopPropagation()"
                          [placeholder]="placeholder || 'Search'"
                          (inputChanged)="filterOptions($event)"
                          (inputCleared)="clearSearch($event)"
                          [allowAccountSelection]="allowAccountSelection"
                          [accountIds]="allowedAccountIds"
                          [selectElementRef]="matSelect"
                          (relayAccountsSelected)="onAccountsChanged($event)"
                          [delay]="300">
      </option-list-search>

      @if (loadedItems.length == 0 && !sapi.loadNext) {
        <mat-option class="no-results"
        >{{noItemsAvailableMessage ? noItemsAvailableMessage : 'No results found!'}}
        </mat-option>
      }
      @if (value?.attributes) {
        <mat-option
            [value]="value"
            class="with-account-row mat-selected">
          <div class="select-item-name selected" [dblClickCopy]="value?.attributes?.name"
               style="color: #666666;">{{value.attributes | nameAndDescription}}
          </div>
          <div class="account-name select-item-account-name" style="justify-content: center;">Selected</div>
        </mat-option>
      }
      @if (allow_none) {
        <mat-option [value]="" style="color: #666666;">(none)</mat-option>
      }
      @for (option of loadedItems; track option) {
        @if (value?.id != option.value?.id) {
          <mat-option
              [dblClickCopy]="option.value?.attributes?.name || option['text']"
              [style.font-weight]="value?.id==option.value?.id ? 'bold' : 'normal'"
              [value]="option['value']"
              [matTooltip]="option['text']"
              [matTooltipShowDelay]="tooltipShowDelay"
              class="with-account-row">
            <div class="select-item-name">{{option.text}}</div>
            @if (option.value?.attributes?.account_name && value?.id !== option.value?.id) {
              <div class="account-name">
                {{option.value.attributes.account_name}}
              </div>
            }
          </mat-option>
        }
      }
      @if (!loadedItems || sapi.loadingAvailable) {
        <mat-option class="option-loading">
          <div class="stage">
            <div class="dot-flashing"></div>
          </div>
        </mat-option>
      }


    </div>
  </mat-select>
</mat-form-field>
